import React from 'react';
import { PRODUCT_IMG, CHECKOUT_URL } from './constants';
interface ProductImageProps {
  className?: string;
  alt?: string;
  /** When true, links straight to checkout instead of scrolling to the offer section. */
  toCheckout?: boolean;
}

/** Product shot — always links to the offer (or straight to checkout). */
export function ProductImage({
  className = '',
  alt = 'PE Teacher Pro complete 6-in-1 ready-to-teach system',
  toCheckout = false
}: ProductImageProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (toCheckout) return;
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <a href={toCheckout ? CHECKOUT_URL : '#pricing'} onClick={handleClick} className="block mx-auto w-full" aria-label={toCheckout ? 'Get instant access' : 'Go to the offer'} data-id="element-140" data-mp="1xok6tcm7i53n">
      <img src={PRODUCT_IMG} alt={alt} className={`w-full h-auto object-contain mx-auto drop-shadow-2xl hover:scale-[1.02] transition-transform duration-200 ease-out ${className}`} data-id="element-141" data-mp="3s1s9trkc5n0d" />
    </a>;
}